module.exports = __webpack_public_path__ + "media/images/emoticons/taurus-a67a24192d9853276a011a5a21caa8bc.gif";